// Autogenerated file
export const distributionBidPaymentTypesEnum = {
    Customer: "Customer",
    HiredCar: "HiredCar",
};
export const distributionBidPaymentTypes = [
    { label: "Расчёты с заказчиком", value: "Customer" },
    { label: "Расчёты с перевозчиком", value: "HiredCar" },
];
